export default {
    "Success": true,
    "htmlMessage": null,
    "Data": {
        "count": 5,
        "value": [
            {
                "id": "be2b822c-e721-4619-9a13-f1366e722c5d",
                "name": "DevOps Playground",
                "description": "Stuff\n",
                "url": "https://dev.azure.com/limeade/_apis/projects/be2b822c-e721-4619-9a13-f1366e722c5d",
                "state": "wellFormed",
                "revision": 414422843,
                "visibility": "private",
                "lastUpdateTime": "2020-01-23T07:02:57.86Z",
                "visible":false
            },
            {
                "id": "3a898514-e95b-432b-9dfe-d9bd38829db0",
                "name": "RD Workflow Test",
                "url": "https://dev.azure.com/limeade/_apis/projects/3a898514-e95b-432b-9dfe-d9bd38829db0",
                "state": "wellFormed",
                "revision": 414422772,
                "visibility": "private",
                "lastUpdateTime": "2019-07-29T18:34:06.777Z",
                "visible":false
            },
            {
                "id": "7c141f74-2e40-4873-9699-55266a7d5518",
                "name": "BI",
                "description": "BI codebase for ETL pipelines, data warehousing, data science, infrastructure and tooling, Python libraries, Docker images, and more.",
                "url": "https://dev.azure.com/limeade/_apis/projects/7c141f74-2e40-4873-9699-55266a7d5518",
                "state": "wellFormed",
                "revision": 414423015,
                "visibility": "private",
                "lastUpdateTime": "2020-04-16T22:07:47.247Z",
                "visible":false
            },
            {
                "id": "ce21a06c-ef13-49a0-a3ea-9bed5121c0c1",
                "name": "DS",
                "description": "Follows TDSP, an Agile process flow that is specifically tailored for Data Science.",
                "url": "https://dev.azure.com/limeade/_apis/projects/ce21a06c-ef13-49a0-a3ea-9bed5121c0c1",
                "state": "wellFormed",
                "revision": 414423079,
                "visibility": "private",
                "lastUpdateTime": "2021-01-05T15:48:31.943Z",
                "visible":false
            },
            {
                "id": "d06389cd-a286-46fa-9a08-b6840b81a699",
                "name": "ONE",
                "description": "Anything to do with ONE. This include mobile apps, platform code, MicroApps/Card and builds and deployments.",
                "url": "https://dev.azure.com/limeade/_apis/projects/d06389cd-a286-46fa-9a08-b6840b81a699",
                "state": "wellFormed",
                "revision": 414423087,
                "visibility": "private",
                "lastUpdateTime": "2021-04-13T18:41:28.857Z",
                "visible":true
            }
        ]
    }
}